// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_ncx-admin_ncx-admin_module_ts":"3db175c5ee9cae80","src_app_ncx-dev_ncx-dev_module_ts":"fb699939ab62e15c"}[chunkId] + ".js";
};